import Accordion from '@/common/components/Accordion'
import InfoField from '@/common/components/InfoField'

interface FipeEquipmentsAccordionProps {
  equipments?: string[]
}

export default function FipeEquipmentsAccordion({ equipments }: FipeEquipmentsAccordionProps) {
  return (
    <Accordion
      name="Equipments"
      head="Equipamentos"
      defaultOpen
      body={
        <div className='grid grid-cols-3 gap-1'>
          {equipments && equipments.length > 0 ? (
            equipments.map((item, index) => (
              <InfoField 
                key={`${item}-${index}`} 
                value={item} 
              />
            ))
          ) : (
            <InfoField value={null} />
          )}
        </div>
      }
    />
  )
}